var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInsuranceGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8801 14.8266C27.8801 21.3466 23.1468 27.4533 16.6801 29.24C16.2401 29.36 15.7601 29.36 15.3201 29.24C8.85344 27.4533 4.12012 21.3466 4.12012 14.8266V8.97329C4.12012 7.87995 4.9468 6.63996 5.97347 6.22662L13.4001 3.18667C15.0668 2.50667 16.9468 2.50667 18.6134 3.18667L26.0401 6.22662C27.0535 6.63996 27.8935 7.87995 27.8935 8.97329L27.8801 14.8266Z",
    stroke: "#10182F",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 16.6667C17.4727 16.6667 18.6666 15.4728 18.6666 14C18.6666 12.5273 17.4727 11.3333 15.9999 11.3333C14.5272 11.3333 13.3333 12.5273 13.3333 14C13.3333 15.4728 14.5272 16.6667 15.9999 16.6667Z",
    stroke: "#10182F",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.6667V20.6667",
    stroke: "#10182F",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInsuranceGrey);
export default __webpack_public_path__ + "static/media/ic-insurance-grey.42386f7f1c6e6a60a3bb38fc000e544e.svg";
export { ForwardRef as ReactComponent };